export enum RouteNames {
  POS = 'route_pos',
  CRM = 'route_crm',
  MANAGEMENT = 'route_management',
  SETTINGS = 'route_settings',
  REPORTING = 'route_reporting',
  ANALYTICS = 'route_analytics',
  BOOKING = 'route_booking',
}

export enum DirectiveNames {
  FUNCTION_SWITCH_TABLE = 'function_switch_table',
  FUNCTION_LAST_BILL = 'function_last_bill',
  FUNCTION_PRINT_LAST_KITCHEN_SLIP = 'function_print_last_kitchen_slip',
  FUNCTION_PRINT_LAST_ORDER_DOCKET = 'function_print_last_order_docket',
  FUNCTION_PRINT_FULL_ORDER_DOCKET = 'function_print_full_order_docket',
  FUNCTION_NOTE = 'function_note',
  FUNCTION_DELETE_BILL = 'function_delete_bill',
  FUNCTION_PERCENT_DISCOUNT = 'function_percent_discount',
  FUNCTION_FLAT_DISCOUNT = 'function_flat_discount',
  FUNCTION_QR_CODE = 'function_qr_code',
  FUNCTION_PAY_IN = 'function_pay_in',
  FUNCTION_PAY_OUT = 'function_pay_out',
  FUNCTION_OPEN_DRAWER = 'function_open_drawer',
  FUNCTION_VOID = 'function_void',
  FUNCTION_VOID_AND_DUPLICATE = 'function_void_and_duplicate',
  FUNCTION_RECEIPT = 'function_receipt',
  FUNCTION_REPRINT = 'function_reprint',
  FUNCTION_ADD_CUSTOMER = 'function_add_customer',
  FUNCTION_CHANGE_PAYMENT = 'function_change_payment',
  FUNCTION_CHECK = 'function_check',
  FUNCTION_PAY_AT_COUNTER = 'function_pay_at_counter',
  FUNCTION_MERGE_TABLE = 'function_merge_table',
  FUNCTION_ADD_SALESPERSON = 'function_add_salesperson',
  ITEM_EDITOR_FLAT_DISCOUNT = 'item_editor_flat_discount',
  ITEM_EDITOR_PERCENT_DISCOUNT = 'item_editor_percent_discount',
  ITEM_EDITOR_DELETE = 'item_editor_delete',
  ITEM_EDITOR_NOTE = 'item_editor_note',
  ITEM_EDITOR_DUPLICATE = 'item_editor_duplicate',
  ITEM_EDITOR_TAKEAWAY = 'item_editor_takeaway',
  ITEM_EDITOR_TRANSFER = 'item_editor_transfer',
  ITEM_EDITOR_SALES_PERSON = 'item_editor_sales_person',
  ITEM_EDITOR_CHANGE_PRICE = 'item_editor_change_price',

  TABLE_EDITOR = 'table_editor',

  FUNCTION_STOCK_ADJUST = 'function_stock_adjust',
  FUNCTION_STOCK_HISTORY = 'function_stock_history',
  FUNCTION_CRM_ADD_CUSTOMER = 'function_crm_add_customer',
  FUNCTION_CRM_EDIT_CUSTOMER = 'function_crm_edit_customer',
  FUNCTION_CRM_DELETE_CUSTOMER = 'function_crm_delete_customer',
}

export enum PageNames {
  MANAGEMENT_REPORT_PAGE = 'management_report_page',
  MANAGEMENT_INVENTORY_PAGE = 'management_inventory_page',
  MANAGEMENT_INVOICES_PAGE = 'management_invoices_page',
  MANAGEMENT_PRODUCT_PAGE = 'management_product_page',
  MANAGEMENT_EMPLOYEE_PAGE = 'management_employee_page',
  MANAGEMENT_SETUP_PAGE = 'management_setup_page'
}


export type IPermissions = {
  routes: {
    [key in RouteNames]: string;
  };
  pages: {
    [key in PageNames]: string;
  }
  directives: {
    [key in DirectiveNames]: string;
  };
}
